import React from 'react';
import type { GridApi } from 'ag-grid-community';

import useIsDataTable from 'components/DataTable/useIsDataTable';

import usePaceMatrixContent from './usePaceMatrixContent';
import PaceMatrixDataTableView from './PaceMatrixDataTableView';
import PaceMatrixView from './PaceMatrixView';

const PaceMatrixContentContainer = ({
  gadget,
  gridApi,
  setGridApi,
  setExportHandle,
}: {
  gadget: VisualisationDefinitions.PaceMatrix;
  gridApi?: GridApi;
  setGridApi: React.Dispatch<React.SetStateAction<GridApi | undefined>>;
  // What export menus use in place of the gridApi when DataTable draws it
  setExportHandle?: (handle: DataTable.ExportHandle | undefined) => void;
}) => {
  const isDataTable = useIsDataTable('paceMatrix');
  const props = usePaceMatrixContent({ gadget, gridApi, setGridApi });
  return isDataTable ? (
    <PaceMatrixDataTableView {...props} setExportHandle={setExportHandle} />
  ) : (
    <PaceMatrixView {...props} />
  );
};

export default PaceMatrixContentContainer;
